var exports = {
  "kL": "SwitchGroup.module__container___eGdfSW",
  "AS": "SwitchGroup.module__item___eGdfSW",
  "Ly": "SwitchGroup.module__itemContent___eGdfSW",
  "IR": "SwitchGroup.module__itemLabel___eGdfSW",
  "a": "SwitchGroup.module__itemLabelInteractive___eGdfSW",
  "r9": "SwitchGroup.module__disabled___eGdfSW",
  "QK": "SwitchGroup.module__labelText___eGdfSW",
  "LE": "SwitchGroup.module__shortcut___eGdfSW",
  "ce": "SwitchGroup.module__extraContent___eGdfSW",
};

module.exports = exports;
